/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Export" |
*
* @param {Speakers_Metrics_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_export_button = /** @type {((inputs?: Speakers_Metrics_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Export")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Export")
	if (locale === "es") return /** @type {LocalizedString} */ ("Export")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Export")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Export")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Export")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Export")
	return /** @type {LocalizedString} */ ("Export")
});